import { Button } from "@/components/ui/button";
import useAccessTokenData from "@/hooks/use-access-token-data";
import { useUserSwitchLogic } from "@/hooks/use-user-switch-logic";
import { SkipForward } from "lucide-react";
import { FC } from "react";

interface SkipButtonProps {
  onSkip?: () => void;
}

const SkipButton: FC<SkipButtonProps> = ({ onSkip }) => {
  const accessTokenData = useAccessTokenData();
  const { skipUser } = useUserSwitchLogic();

  if (
    !accessTokenData?.switchInfoId ||
    !accessTokenData?.switchInfoLength ||
    accessTokenData?.switchInfoIndex === undefined ||
    accessTokenData?.switchInfoIndex === accessTokenData?.switchInfoLength - 1
  ) {
    return null;
  }

  const handleSkip = async () => {
    if (onSkip) {
      onSkip();
    } else {
      try {
        const result = await skipUser();
        console.log("Результат пропуску:", result);
      } catch (error) {
        console.error("Помилка при пропуску:", error);
        window.location.href = "/";
      }
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleSkip}
      className="flex items-center gap-2 select-none"
    >
      <SkipForward className="h-4 w-4" />
      Пропустити
    </Button>
  );
};

export default SkipButton;
